import {Form, InputGroup} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import PropTypes from 'prop-types';

export default class TextInput extends React.Component{

    render() {
        let {id, placeholder, label, value, centered, readOnly, icon, isError, errorMessage, size, capitalized} = this.props
        if(!id){
            id = "text"
        }
        if(!label){
            label = ""
        }
        if(!placeholder){
            placeholder = label
        }
        return (
            <Form.Group id={id} className={"mb-4 "+(this.props.clickable?"clickable-input ":" "+(centered?"text-center":""))}>
                <Form.Label className={(centered?"text-center":"")}>{label}</Form.Label>
                <InputGroup className={(this.props.clickable?"clickable-input":"")} size={size}>
                    {icon&&(
                        <InputGroup.Text style={{borderColor:(isError?'#FA5252':'')}}>
                            <FontAwesomeIcon icon={icon} />
                        </InputGroup.Text>
                    )}
                    <Form.Control
                        autoFocus
                        required={this.props.required}
                        type="text"
                        placeholder={readOnly?"":placeholder}
                        onChange={(e)=>{
                            if(capitalized){
                                if (this.props.onChange) {
                                    const capitalized = e.target.value.replace(/\b\w/g, char => char.toUpperCase());
                                    this.props.onChange(capitalized);
                                }
                            }else{
                                if(this.props.onChange){
                                    this.props.onChange(e.target.value)
                                }
                            }
                        }}
                        isInvalid={isError}
                        value={value?value:""}
                        readOnly={readOnly}
                        onClick={this.props.onClick}
                        style={this.props.style}
                        size={size}
                        className={"autoCapitalize "+(this.props.clickable?"clickable-input ":" ")+(centered?"text-center":"")}
                    />
                </InputGroup>
                {isError&&(
                    <Form.Control.Feedback type="invalid" style={{display:'unset', position:'absolute'}}>{errorMessage?errorMessage:placeholder}</Form.Control.Feedback>
                )}
            </Form.Group>
        );
    }
}
TextInput.propTypes = {
    label:PropTypes.string.isRequired,
    value:PropTypes.string,
    placeholder:PropTypes.string,
    icon:PropTypes.any,
    required:PropTypes.bool,
    readOnly:PropTypes.bool,
    size:PropTypes.string,
    centered:PropTypes.bool,
    onChange:PropTypes.func,
    isError:PropTypes.bool,
    errorMessage:PropTypes.string,
    clickable:PropTypes.bool,
    capitalized:PropTypes.bool,
    onClick:PropTypes.func
}